"use client"

import React from 'react';
// import HomePage from "@/app/(index)/home-v1";
import HomePage from "@/app/(index)/home-v2";

export default function Page() {
    return (
        <>
            {/*<HomePageV1/>*/}
            <HomePage/>
        </>
    );
}